import { Draggable, Slider as SliderCore } from "@studiometa/ui";

export default class Slider extends SliderCore {
  static config = {
    ...super.config,
    name: 'Slider',
    options: {
      ...super.config.options,
      draggable: true,
      autoPlay: false
    }
  };
}
